var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    keyTimes: "0;0.0238095;0.1095238;0.5380952;0.6285714;0.6952381;0.7428571;1",
    path: "M34 34 C34,34 34,34 34,34 C34,34 37.75,39.75 37.75,39.75 C37.75,39.75 37.75,39.75 37.75,39.75 C37.75,39.75 31.42,32.65 31.42,32.65 C31.42,32.65 35.63,34.63 35.63,34.63 C35.63,34.63 34,34 34,34 C34,34 34,34 34,34 ",
    keyPoints: "0;0;0.3;0.3;0.72;0.92;1;1",
    keySplines: "0.333 0 0.667 1;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 0.786;0.333 0.322 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 0,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.0238095;0.1095238;0.5380952;0.6285714;0.6952381;0.7428571;1",
    values: "0;0;11.696;11.696;-1.471;0;0;0",
    keySplines: "0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 0.737;0.333 0 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-34 -34",
    to: "-34 -34",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-34 -34;-34 -34",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 0,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.0904762;0.1286571;0.1668333;0.2050048;0.243181;0.2813524;0.3237714;0.3619524;0.400119;0.4383;0.4775952;0.5157714;0.6347381;0.687119;0.7347377;1",
    values: "0;106.383;96.494;106.383;96.494;106.383;96.494;106.383;96.494;106.383;96.494;106.383;96.494;-12.763;8.458;0;0",
    keySplines: "0.167 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.833 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-34 -34",
    to: "-34 -34",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-34 -34;-34 -34",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_N_2_T_0",
    fill: "freeze",
    keyTimes: "0;0.0238095;0.1095238;0.5380952;0.6285714;0.6952381;0.7428571;1",
    path: "M34 34 C34,34 34,34 34,34 C34,34 37.75,39.75 37.75,39.75 C37.75,39.75 37.75,39.75 37.75,39.75 C37.75,39.75 31.42,32.65 31.42,32.65 C31.42,32.65 35.63,34.63 35.63,34.63 C35.63,34.63 34,34 34,34 C34,34 34,34 34,34 ",
    keyPoints: "0;0;0.3;0.3;0.72;0.92;1;1",
    keySplines: "0.333 0 0.667 1;0.333 0 0.667 1;0.333 0.333 0.667 0.667;0.333 0 0.667 0.786;0.333 0.322 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_N_2_T_0",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 0,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.0238095;0.1095238;0.5380952;0.6285714;0.6952381;0.7428571;1",
    values: "0;0;11.696;11.696;-1.471;0;0;0",
    keySplines: "0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 0.737;0.333 0 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "3.5s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_N_2_T_0",
    fill: "freeze",
    attributeName: "transform",
    from: "-34 -34",
    to: "-34 -34",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-34 -34;-34 -34",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "opacity",
    dur: "4s",
    from: 0,
    to: 1,
    xlinkHref: "#time_group"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_R_G"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_1_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_0_P_0",
    fill: "#f2a468",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M58.86 18.06 C58.84,18.02 58.83,17.98 58.81,17.94 C58.78,17.89 58.75,17.86 58.72,17.82 C56.23,13.6 52.68,10.07 48.43,7.6 C48.39,7.57 48.36,7.54 48.32,7.52 C48.28,7.5 48.23,7.48 48.19,7.46 C44,5.08 39.16,3.71 34,3.71 C34,3.71 34,3.71 34,3.71 C28.84,3.71 23.99,5.08 19.81,7.46 C19.76,7.48 19.72,7.5 19.68,7.52 C19.64,7.54 19.61,7.57 19.57,7.6 C15.32,10.07 11.77,13.6 9.28,17.83 C9.25,17.86 9.22,17.9 9.2,17.94 C9.17,17.98 9.16,18.02 9.14,18.06 C6.74,22.22 5.36,27.03 5.36,32.16 C5.36,39.76 8.34,46.91 13.75,52.29 C19.16,57.66 26.35,60.62 34,60.62 C34,60.62 34,60.62 34,60.62 C41.65,60.62 48.84,57.66 54.25,52.29 C59.66,46.91 62.64,39.77 62.64,32.16 C62.64,27.04 61.26,22.22 58.86,18.06z  M52.14 50.16 C47.29,54.97 40.85,57.62 34,57.62 C34,57.62 34,57.62 34,57.62 C27.15,57.62 20.71,54.97 15.86,50.16 C14.63,48.93 13.53,47.59 12.59,46.17 C12.59,46.17 17.12,43.57 17.12,43.57 C17.84,43.16 18.09,42.24 17.67,41.52 C17.26,40.8 16.34,40.56 15.63,40.97 C15.63,40.97 11.08,43.58 11.08,43.58 C9.53,40.51 8.61,37.16 8.41,33.66 C8.41,33.66 13.66,33.66 13.66,33.66 C14.49,33.66 15.16,32.99 15.16,32.16 C15.16,31.33 14.49,30.66 13.66,30.66 C13.66,30.66 8.41,30.66 8.41,30.66 C8.62,27.12 9.56,23.77 11.09,20.75 C11.09,20.75 15.63,23.35 15.63,23.35 C15.86,23.49 16.12,23.56 16.37,23.56 C16.89,23.56 17.4,23.28 17.67,22.8 C18.09,22.08 17.84,21.17 17.12,20.75 C17.12,20.75 12.6,18.16 12.6,18.16 C14.52,15.28 17.01,12.81 19.91,10.91 C19.91,10.91 22.53,15.41 22.53,15.41 C22.8,15.89 23.31,16.15 23.82,16.15 C24.08,16.15 24.34,16.09 24.58,15.95 C25.29,15.54 25.54,14.62 25.12,13.9 C25.12,13.9 22.51,9.42 22.51,9.42 C25.55,7.9 28.93,6.96 32.5,6.76 C32.5,6.76 32.5,11.95 32.5,11.95 C32.5,12.78 33.17,13.45 34,13.45 C34.83,13.45 35.5,12.78 35.5,11.95 C35.5,11.95 35.5,6.76 35.5,6.76 C39.07,6.96 42.45,7.9 45.49,9.42 C45.49,9.42 42.88,13.9 42.88,13.9 C42.47,14.62 42.71,15.54 43.42,15.95 C43.66,16.09 43.92,16.15 44.18,16.15 C44.69,16.15 45.2,15.89 45.48,15.41 C45.48,15.41 48.09,10.91 48.09,10.91 C50.99,12.81 53.48,15.28 55.4,18.16 C55.4,18.16 50.88,20.75 50.88,20.75 C50.16,21.17 49.92,22.08 50.33,22.8 C50.6,23.28 51.11,23.56 51.63,23.56 C51.88,23.56 52.14,23.49 52.37,23.35 C52.37,23.35 56.91,20.76 56.91,20.76 C58.44,23.77 59.38,27.12 59.59,30.66 C59.59,30.66 54.36,30.66 54.36,30.66 C53.53,30.66 52.86,31.33 52.86,32.16 C52.86,32.99 53.53,33.66 54.36,33.66 C54.36,33.66 59.59,33.66 59.59,33.66 C59.39,37.16 58.47,40.51 56.92,43.58 C56.92,43.58 52.37,40.97 52.37,40.97 C51.66,40.56 50.74,40.8 50.33,41.52 C49.92,42.24 50.16,43.16 50.88,43.57 C50.88,43.57 55.42,46.17 55.42,46.17 C54.47,47.59 53.38,48.93 52.14,50.16z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_1_P_0",
    fill: "#f2a468",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M42.52 52.9 C42.52,52.9 25.48,52.9 25.48,52.9 C23.53,52.9 21.95,51.33 21.95,49.39 C21.95,49.39 21.95,46.69 21.95,46.69 C21.95,44.75 23.53,43.17 25.48,43.17 C25.48,43.17 42.52,43.17 42.52,43.17 C44.47,43.17 46.05,44.75 46.05,46.69 C46.05,46.69 46.05,49.39 46.05,49.39 C46.05,51.33 44.47,52.9 42.52,52.9z  M25.48 46.17 C25.19,46.17 24.95,46.41 24.95,46.69 C24.95,46.69 24.95,49.39 24.95,49.39 C24.95,49.67 25.19,49.9 25.48,49.9 C25.48,49.9 42.52,49.9 42.52,49.9 C42.81,49.9 43.05,49.67 43.05,49.39 C43.05,49.39 43.05,46.69 43.05,46.69 C43.05,46.41 42.81,46.17 42.52,46.17 C42.52,46.17 25.48,46.17 25.48,46.17z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G_N_2_T_0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G",
    transform: " translate(34, 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_0_P_0",
    fill: "#f2a468",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M34 37.97 C31.41,37.97 29.31,35.87 29.31,33.3 C29.31,32.94 29.35,32.59 29.43,32.24 C29.43,32.24 32.53,17.78 32.53,17.78 C32.68,17.08 33.29,16.59 34,16.59 C34.71,16.59 35.32,17.08 35.47,17.78 C35.47,17.78 38.57,32.27 38.57,32.27 C38.65,32.58 38.69,32.94 38.69,33.3 C38.69,35.87 36.59,37.97 34,37.97z  M34 25.24 C34,25.24 32.36,32.9 32.36,32.9 C32.32,33.05 32.31,33.17 32.31,33.3 C32.31,34.22 33.07,34.97 34,34.97 C34.93,34.97 35.69,34.22 35.69,33.3 C35.69,33.17 35.67,33.05 35.65,32.93 C35.65,32.93 34,25.24 34,25.24z "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "time_group"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitReminder);
export default __webpack_public_path__ + "static/media/limit_reminder.952ca88ab5dccc8d49e5ecdd0d8dad0f.svg";
export { ForwardRef as ReactComponent };